export default "__VITE_ASSET__Cir6Ja2z__"